module.exports = "/_next/static/images/GettingStarted3-af7930189deb3735fb14f970ba4081a8.png";